import { paletteForSlug } from '@/utils/agent_catalog';

export function colorForPromptCategory(slug) {
  return paletteForSlug(slug || '');
}

export function sortPrompts(prompts, sortId = 'relevant', catalogIndexBySlug = new Map()) {
  const list = [...(prompts || [])];
  const catalogIndex = (slug) => {
    const i = catalogIndexBySlug.get(slug);
    return i == null ? Number.MAX_SAFE_INTEGER : i;
  };
  const runCount = (p) => Number(p?.stats?.runCount) || 0;

  switch (sortId) {
    case 'popular':
      return list.sort((a, b) => {
        const ra = runCount(a);
        const rb = runCount(b);
        if (rb !== ra) return rb - ra;
        return catalogIndex(a.slug) - catalogIndex(b.slug);
      });
    case 'name-asc':
      return list.sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }),
      );
    case 'name-desc':
      return list.sort((a, b) =>
        (b.name || '').localeCompare(a.name || '', undefined, { sensitivity: 'base' }),
      );
    case 'category':
      return list.sort((a, b) => {
        const aHas = typeof a.category === 'object' && a.category?.name;
        const bHas = typeof b.category === 'object' && b.category?.name;
        if (aHas && !bHas) return -1;
        if (!aHas && bHas) return 1;
        if (!aHas && !bHas) {
          return (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' });
        }
        const byCat = a.category.name.localeCompare(b.category.name, undefined, { sensitivity: 'base' });
        if (byCat !== 0) return byCat;
        return (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' });
      });
    case 'relevant':
    default:
      return list.sort((a, b) => catalogIndex(a.slug) - catalogIndex(b.slug));
  }
}

/** Unique model slugs from loaded prompts (for filter pills). */
export function collectModelSlugsFromPrompts(prompts = []) {
  const seen = new Map();
  for (const p of prompts) {
    const m = p?.defaultModel;
    const slug = m?.slug;
    if (!slug || seen.has(slug)) continue;
    seen.set(slug, m?.name || slug);
  }
  return [...seen.entries()].map(([slug, name]) => ({ slug, name }));
}

/** Unique tag strings from loaded prompts. */
export function collectTagsFromPrompts(prompts = []) {
  const tags = new Set();
  for (const p of prompts) {
    for (const tag of p?.tags || []) {
      if (tag) tags.add(String(tag));
    }
  }
  return [...tags].sort((a, b) => a.localeCompare(b));
}
